import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import { Box, Link, Drawer, Typography, Avatar } from "@mui/material";
import useResponsive from "../../../hooks/use-responsive";
import Logo from "../../../components/logo";
import Scrollbar from "../../../components/scrollbar";
import NavSection from "../../../components/nav-section";
import { navConfig, navConfigAdmin } from "./config";
import { GetLocalStorage } from "../../../utils/local-storage";
import { usePersistentState } from "../../../contexts/global-context";
import { STRING } from "../../../resources/string";
import APIS from "../../../config/api";
import { GET } from "../../../config/https";

const NAV_WIDTH = 280;

const StyledAccount = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }: any) {
  const { pathname } = useLocation();
  const [state]: any = usePersistentState();

  const [loginInfo, setLoginInfo] = useState<any>(false);
  const [user, setUser] = useState<any>({});

  const isDesktop = useResponsive("up", "lg", "");
  useEffect(() => {
    let loginData = GetLocalStorage("loginData");
    setLoginInfo(loginData);
  }, [state.users]);
  useEffect(() => {
    let userInfo = GetLocalStorage("userInfo");
    setUser(userInfo);
  }, []);

  // const GetUserData = async () => {
  //   let userData = GetLocalStorage("loginData");
  //   let params: any = {
  //     id: userData.id,
  //   };
  //   await GET(APIS.GET_USER_BY_ID, params)
  //     .then((res: any) => {
  //       if (res?.isSuccess) {
  //         setUser(res.result);
  //       } else {
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //     })
  //     .finally(() => {});
  // };
  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: "inline-flex" }}>
        <Logo />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar src={user?.profileImage} alt="photoURL" />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: "text.primary" }}>
                {loginInfo.firstName} {loginInfo.lastName}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>
      <NavSection
        data={
          loginInfo?.roles?.id === 1 ||
          loginInfo?.roles?.name?.toLowerCase() === "admin"
            ? navConfigAdmin
            : navConfig
        }
      />
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: "background.default",
              borderRightStyle: "dashed",
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
